// extracted by mini-css-extract-plugin
export default {"headerContainer":"PlaylistsHeader_headerContainer__sAZiQ","search":"PlaylistsHeader_search__blRwj","coursesFilter":"PlaylistsHeader_coursesFilter__2Y3GE"};